import { gql } from '@apollo/client';

/**
 * The Quote Generator's read of the live pricing catalog (staff-api → read-only Mongo:
 * deviceProducts + deviceShippings + productPlans). The nested price maps arrive as JSON
 * strings — see apps/api/src/app/quote/quote.response.ts for why — and are parsed by
 * `useQuoteCatalog` before reaching the pricing engine.
 */
export const STAFF_QUOTE_CATALOG = gql`
  query StaffQuoteCatalog {
    staffQuoteCatalog {
      products {
        _id
        name
        description
        alias
        variantId
        price
        pricesJson
        isKiosk
      }
      shippings {
        _id
        name
        pricesJson
      }
      plans {
        _id
        name
        alias
        plansJson
      }
      addOns {
        key
        name
        type
        order
        pricesJson
        minQuantity
        defaultTier
        limitCurrencies
        isAutoConvertCurrency
        stripeRatesJson
        tiers {
          key
          name
          priceKeys
        }
      }
      plansCollection
    }
  }
`;

/** Hardware (US only): the products the section can offer. Server: app/quote/quote-hardware.service.ts. */
export const STAFF_QUOTE_HARDWARE = gql`
  query StaffQuoteHardware {
    staffQuoteHardware {
      sku
      stripePriceId
      name
      unitAmountMinor
      quotable
    }
  }
`;

/** Hardware (US only): products + Standard US freight for the rows picked. Read-only. */
export const STAFF_QUOTE_HARDWARE_PRICE = gql`
  query StaffQuoteHardwarePrice($hardware: [QuoteHardwareInput!]!) {
    staffQuoteHardwarePrice(hardware: $hardware) {
      lines {
        kind
        key
        label
        quantity
        unitAmountMinor
        amountMinor
      }
    }
  }
`;
